














































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
// components
import ChannelAddPostModal from "@/components/channels/modals/ChannelAddPostModal.vue";
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import PostDeleteModal from "@/components/channels/modals/PostDeleteModal.vue";
import PostCopyModal from "@/components/channels/modals/PostCopyModal.vue";
import ChannelAddHtmlPostTemplateModal from "@/components/channels/modals/ChannelAddHtmlPostTemplateModal.vue";
import ChannelAddCustomPostTemplateModal from "@/components/channels/modals/ChannelAddCustomPostTemplateModal.vue";

// role status
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

// service methods
import { getActiveDays, getFilteredPosts, disablePost, enablePost, swapPostOrder, LocalizeType, FormatDate, LocalizeAllday, CalculateShowtime } from "@/services/posts/postsService";
import { getAllContentTemplateSizes } from "@/services/contentTemplates/contentTemplateService";
// types
import { Post, ActiveDaysRequest, MarkedDay, PostsFilterDtoIn } from "@/services/posts/types";
import { calendarConfigs } from "@/services/functional-calendar";
import draggable from "vuedraggable";

const namespace: string = "authentication";

@Component({
    components: {
        "channel-add-post-modal": ChannelAddPostModal,
        "functional-calendar": FunctionalCalendar,
        "post-delete-modal": PostDeleteModal,
        "post-copy-modal": PostCopyModal,
        ChannelAddHtmlItemTemplateModal: ChannelAddHtmlPostTemplateModal,
        draggable,
        ChannelAddCustomPostTemplateModal
    }
})
export default class ChannelPosts extends Vue {
    @Prop() channelId!: string;
    @Prop() selectedPostTypes!: string[];
    @Prop() isEditor!: boolean;
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    // local state
    localItems = [] as Post[];
    calendar = {} as any;
    markedDates = [] as Array<MarkedDay>;
    isBusy = false;
    selectedChannelId = "";

    // role states
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;

    // filter options
    searchQuery = "";

    // calendar
    showCalendar = true;
    currentSelectedDate = new Date();

    localizeType = LocalizeType;
    formatDate = FormatDate;
    localizeAllDay = LocalizeAllday;
    calculateShowtime = CalculateShowtime;

    // lifecycle hooks
    created() {
        this.loadActiveDays(this.firstDayOfThisMonth);
    }

    mounted() {
        const today = new Date();
        (this.$refs.calendar as any).clickDay({
            day: today.getDate(),
            date: `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`,
            hide: false,
            isMouseToLeft: false,
            isMouseToRight: false,
            isHovered: false,
            isDateRangeStart: false,
            isDateRangeEnd: false,
            hideLeftAndRightDays: false,
            isToday: false,
            isMarked: true
        });
    }

    // Watchers
    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showCalendar = !value;
    }

    @Watch("showCalendar")
    onShowCalendarChanged(value: boolean, oldValue: any) {
        if (value) {
            this.loadItems(this.currentSelectedDate);
        } else {
            this.loadItems("");
        }
    }

    // computed properties
    get firstDayOfThisMonth(): Date {
        const today = new Date();
        const month = today.getMonth();
        const year = today.getFullYear();
        return new Date(year, month, 1);
    }

    get firstDayOfMonthOfSelectedDate(): Date {
        const month = this.currentSelectedDate.getMonth();
        const year = this.currentSelectedDate.getFullYear();
        return new Date(year, month, 1);
    }

    get filteredData() {
        return (
            this.localItems &&
            this.localItems.filter(
                x =>
                    this.searchQuery.length === 0 ||
                    x.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            )
        );
    }

    get isAdmin() : boolean {
        return this.havePermition(this.getCurrentUser.permissions,
            this.permitionEnum[this.permitionEnum.AdminPrivilege]);
    }

    set filteredData(data: any) {
        this.localItems = data;
    }

    get filterActive(): boolean {
        return this.searchQuery !== "";
    }

    get calendarConfigs() {
        return calendarConfigs();
    }

    // calendar events
    dayClicked(day: any) {
        const dateParts = day.date.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.currentSelectedDate = dateObject;
        this.loadItems(dateObject);
    }

    changedMonth(startDate: Date) {
        this.loadActiveDays(startDate);
    }

    // methods and events
    getInitials(name: string) {
        const nameArray = name.split(" ");
        if (nameArray.length === 1) {
            return nameArray[0].charAt(0);
        }

        return `${nameArray[0].charAt(0)}${nameArray[1].charAt(0)}`;
    }

    reload() {
        if (this.showCalendar) {
            this.loadItems(this.currentSelectedDate);
        } else {
            this.loadItems("");
        }
        this.loadActiveDays(this.firstDayOfMonthOfSelectedDate);
        this.$emit("updatePostTypeList");
    }

    loadActiveDays(startDate: Date) {
        getActiveDays({
            channelId: this.channelId,
            calendarStartDate: startDate
        } as ActiveDaysRequest).then(response => {
            let i;
            for (i = 0; i < this.markedDates.length; i++) {
                Vue.set(this.markedDates, i, {});
            }
            response.forEach((date: string, i: number) => {
                Vue.set(this.markedDates, i, {
                    date: date,
                    class: "vfc-marked"
                });
            });
        });
    }

    loadItems(date: any) {
        getFilteredPosts({
            channelId: this.channelId,
            calendarDate: date.toLocaleString("en-US")
        } as PostsFilterDtoIn).then(response => {
            this.localItems = response;
            this.isBusy = false;
        });
    }

    toggleCalendar() {
        this.showCalendar = !this.showCalendar;
    }

    toggleActive(item: Post) {
        if (item.status === "active") {
            disablePost(item.id).then(() => {
                item.status = "inactive";
                this.loadActiveDays(this.firstDayOfMonthOfSelectedDate);
            });
        } else {
            enablePost(item.id).then(() => {
                item.status = "active";
                this.loadActiveDays(this.firstDayOfMonthOfSelectedDate);
            });
            item.status = "active";
        }
    }

    dragEnd(data: any) {
        if (data.newIndex === data.oldIndex) return; // If we didn't move, we don't need to do anything.
        const filteredData: Post[] = JSON.parse(JSON.stringify(this.filteredData));
        const idMap = filteredData.map(x => x.id);
        swapPostOrder(idMap);
    }

    async addItem() {
        // This check will be replaced with ContentTemplate ACL list
        if (this.selectedPostTypes.length > 1) {
            (this.$refs.channelAddItemModal as any).open();
            return;
        }

        if (this.selectedPostTypes[0].toLowerCase() === "html" || this.selectedPostTypes[0].toLowerCase() === "fixedhtml") {
            await this.onHtmlPostModal(this.channelId, this.selectedPostTypes[0]);
            return;
        }

        await this.$router.push({
            name: "createPost",
            params: {
                channelId: this.channelId,
                postType: this.selectedPostTypes[0]
            }
        });
    }

    deletePost(postId: string, name: string) {
        (this.$refs.itemDeleteModal as any).open(postId, name);
    }

    copyPost(postId: string) {
        (this.$refs.itemCopyModal as any).open(postId);
    }

    postDetailsRoute(postId: string) {
        if (this.isAdmin) {
            return {
                name: "updatePost",
                params: {
                    channelId: this.channelId,
                    postId: postId
                }
            };
        } if (this.isEditor) {
            return {
                name: "editorUpdatePost",
                params: {
                    channelId: this.channelId,
                    postId: postId
                }
            };
        }
    }

    async onHtmlPostModal(channelId: string, postType: string) {
        const sizes = await getAllContentTemplateSizes();
        this.selectedChannelId = channelId;

        if (postType.toLowerCase() === "fixedhtml") {
            // Logic  for fixedhtml
            (this.$refs.htmlItemTemplatesModal as any).open(true, sizes, postType);
        } else {
            // Logic for "html = custom "
            if (sizes.filter(x => x.type.toLowerCase() !== "fixedhtml").length > 0) {
                (this.$refs.customItemTemplatesModal as any).open(true, sizes, postType);
            } else {
                await this.$router.push({
                    name: "createPost",
                    params: {
                        channelId: this.selectedChannelId,
                        postType: "html"
                    }
                });
            }
        }
    }
}

